// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentTitle_root__wnz6m","alignment_center":"ContentTitle_alignment_center__0HZAJ","title":"ContentTitle_title__VYJV8","text":"ContentTitle_text__r6_cX"};